import {
    IDENTIFICATION_METHODS,
    INTERNAL_TM_IDENTIFICATION_METHODS,
    IdentificationMethod,
    isD2DDealerCode,
    isExternalRetailDealerGroup,
    isExternalTMDealerCode,
    isInternalTMDealerCode,
    PartialPick,
    D2D_DEALER_GROUP,
} from "../../../../../constants";
import { RootState } from "../../../../../models";
import { Agent, Dealer, RetailerState, SelectedAgent } from "../../../../../models/state";

export * from "./additionalProductsSelectors";
export type State = PartialPick<RootState, "retailer">;

export const getRetailerState = (state: State): Partial<RetailerState> => state.retailer || {};

export const getShops = (state: State): Dealer[] => getRetailerState(state)?.shops || [];
export const getSalesAgent = (state: State): Agent | undefined => getRetailerState(state)?.salesAgent;
export const getSalesAgents = (state: State): Agent[] | [] => getRetailerState(state)?.salesAgents || [];
export const getSelectedAgent = (state: State): SelectedAgent | undefined =>
    getRetailerState(state)?.selectedAgent ?? undefined;
export const getFirebaseUrl = (state: State): string | undefined => getRetailerState(state)?.firebaseUrl ?? undefined;
export const getIsD2DDealer = (state: State): boolean =>
    isD2DDealerCode(getSalesAgent(state)?.dealerCode) || getSalesAgent(state)?.dealerGroup === D2D_DEALER_GROUP;
export const getIsInternalTMDealer = (state: State): boolean =>
    isInternalTMDealerCode(getSalesAgent(state)?.dealerCode);
export const getIsExternalTMDealer = (state: State): boolean =>
    isExternalTMDealerCode(getSalesAgent(state)?.dealerCode);
export const getIsExternalRetail = (state: State): boolean =>
    isExternalRetailDealerGroup(getSalesAgent(state)?.dealerGroup);
export const isTMDealer = (state: State): boolean => getIsExternalTMDealer(state) || getIsInternalTMDealer(state);
// D2D and TM dealers don't stock SIM cards or sell hardware. Unknown dealers keep the full retail flow.
export const getIsD2DOrTMDealer = (state: State): boolean => getIsD2DDealer(state) || isTMDealer(state);
export const getAllowedIdentificationMethods = (state: State): IdentificationMethod[] => {
    const allMethods = Object.keys(IDENTIFICATION_METHODS) as IdentificationMethod[];
    if (getIsInternalTMDealer(state)) {
        return allMethods.filter((method) => INTERNAL_TM_IDENTIFICATION_METHODS.includes(method));
    }
    return allMethods.filter((method) => method !== "KNOWN_BY_SALES_AGENT");
};
